import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../__styling'

export const AppDownloadSection = styled('div')(({ theme }) => ({
    padding: calcRem(28, 0, 0, 0),
    alignItems: 'center',
    height: 'fit-content',

    zIndex: 1,
    position: 'relative',
}))

export const InnerAppDownloadTextSection = styled('div')({
    margin: 'auto 0',
    display: 'flex',
    flexDirection: 'column',

    // Display a full width & smaller gap on mobile devices
    width: '100%',
    gap: calcRem(16),

    // Display only 40% width & larger gap on tablet or larger devices
    [breakpoint('sm')]: {
        width: '40%',
        gap: calcRem(24),
    },
})
